export type EnvironmentKind = 'production' | 'sandbox' | 'staging' | 'local';
export interface EnvironmentLabel {
    kind: EnvironmentKind;
    text: 'PRODUCTION' | 'SANDBOX' | 'STAGING' | 'LOCAL';
}

const HOSTS: Record<string, EnvironmentLabel> = {
    'api.jetfueltenders.com': { kind: 'production', text: 'PRODUCTION' },
    'api.sandbox.jetfueltenders.com': { kind: 'sandbox', text: 'SANDBOX' },
    'api.staging.jetfueltenders.com': { kind: 'staging', text: 'STAGING' },
};

/** Which environment this build talks to, from its API host. Exact host match only. */
export function environmentLabel(apiUrl: string): EnvironmentLabel {
    let host = '';
    try {
        host = new URL(apiUrl).hostname;
    } catch {
        host = '';
    }
    return HOSTS[host] ?? { kind: 'local', text: 'LOCAL' };
}
